<template>
  <div class="voice-control-page">


    <float-menu></float-menu>
    <div class="panel">
      <div class="panel-header">

        <h2 class="panel-title"><i class="fas fa-microphone"></i> 语音场控功能</h2>


        <div class="header-actions">
          <div class="bottom-row">
            <div class="filter-section">

              <div class="filter-group">
                <div class="max-chars-box">
                  <span>昵称最大读</span>
                  <input type="number" v-model="filters.maxChars" class="char-input">
                  <span>个字</span>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-add-voice" @click="showAddVoiceModal = true">+ 新增音色</button>
          <div class="voice-presets">
            <button class="preset-btn active" @click="openVoiceList('female')">
              <i class="fas fa-waveform"></i>
              <span>女生音色</span>
              <span class="voice-count" v-if="voices?.female?.length > 0">{{ voices?.female?.length }}</span>
            </button>
            <button class="preset-btn preset-btn-male" @click="openVoiceList('male')">
              <i class="fas fa-waveform"></i>
              <span>男声音色</span>
              <span class="voice-count" v-if="voices?.male?.length> 0">{{ voices?.male?.length }}</span>
            </button>
            <button class="preset-btn ai-btn" :class="{ active: $store.state.isAIEnabled }" @click="toggleAI">
              <i class="fas fa-robot"></i>
              <span>{{ $store.state.isAIEnabled ? '停止AI主播' : '开启AI主播' }}</span>
            </button>
            <button class="preset-btn ai-reply-btn" :class="{ active: $store.state.isAIReplyEnabled }"
                    @click="toggleAIReply">
              <i class="fas fa-comment-dots"></i>
              <span>{{ $store.state.isAIReplyEnabled ? '停止智能回复' : '开启智能回复' }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="modules-grid" v-if="modules?.anchor">
        <div class="module-card">
          <div class="module-header">
            <div class="header-left">
              <span class="module-title">主播</span>
            </div>
            <label class="checkbox-item">
              <input type="checkbox" v-model="modules?.anchor.enabled" @change="saveConfig">
              <span class="checkbox-custom"></span>
            </label>
          </div>
          <div class="module-body">

            <select class="content-select" v-model="modules?.anchor.id" @change="saveConfig">
              <option :value="item.id" v-for="item in talkList?.anchor">{{ item.name }}</option>
            </select>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-volume">音量</span>
                <i class="fas fa-volume-up"></i>
                <input type="range" min="0" max="100" v-model="modules?.anchor.volume" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.anchor.volume }}</span>
              </div>
            </div>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-tachometer" >语速</span>

                <i class="fas fa-tachometer-alt"></i>
                <input type="range" min="0" max="100" v-model="modules?.anchor.speed" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.anchor.speed - 50 }}</span>
              </div>
            </div>
            <div class="module-footer">
              <span class="interval-label-text">间隔</span>
              <div class="interval-box">
                <input type="number" v-model="modules?.anchor.minInterval" class="interval-input" @change="saveConfig">
                <span>~</span>
                <input type="number" v-model="modules?.anchor.maxInterval" class="interval-input" @change="saveConfig">
                <span class="interval-label">秒随机</span>
              </div>
            </div>
          </div>
        </div>

        <div class="module-card">
          <div class="module-header">
            <span class="module-title">关键词</span>
            <label class="checkbox-item">
              <input type="checkbox" v-model="modules?.keyword.enabled" @change="saveConfig">
              <span class="checkbox-custom"></span>
            </label>
          </div>
          <div class="module-body">

            <select class="content-select" v-model="modules?.keyword.id" @change="saveConfig">
              <option :value="item.id" v-for="item in talkList?.keyword">{{ item.name }}</option>
            </select>

            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-volume">音量</span>

                <i class="fas fa-volume-up"></i>
                <input type="range" min="0" max="100" v-model="modules?.keyword.volume" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.keyword.volume }}</span>
              </div>
            </div>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-tachometer" >语速</span>

                <i class="fas fa-tachometer-alt"></i>
                <input type="range" min="0" max="100" v-model="modules?.keyword.speed" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.keyword.speed - 50 }}</span>
              </div>
            </div>
            <div class="module-footer">
              <span class="interval-label-text">间隔</span>
              <div class="interval-box">
                <input type="number" v-model="modules?.keyword.minInterval" class="interval-input" @change="saveConfig">
                <span>~</span>
                <input type="number" v-model="modules?.keyword.maxInterval" class="interval-input" @change="saveConfig">
                <span class="interval-label">秒随机</span>
              </div>
            </div>
          </div>
        </div>

        <div class="module-card">
          <div class="module-header">
            <span class="module-title">插播报时</span>
            <label class="checkbox-item">
              <input type="checkbox" v-model="modules?.timing.enabled" @change="saveConfig">
              <span class="checkbox-custom"></span>
            </label>
          </div>
          <div class="module-body">
            <select class="content-select" v-model="modules?.timing.id" @change="saveConfig">
              <option :value="item.id" v-for="item in talkList?.timing">{{ item.name }}</option>
            </select>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-volume">音量</span>

                <i class="fas fa-volume-up"></i>
                <input type="range" min="0" max="100" v-model="modules?.timing.volume" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.timing.volume }}</span>
              </div>
            </div>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-tachometer" >语速</span>

                <i class="fas fa-tachometer-alt"></i>
                <input type="range" min="0" max="100" v-model="modules?.timing.speed" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.timing.speed - 50 }}</span>
              </div>
            </div>
            <div class="module-footer">
              <span class="interval-label-text">间隔</span>
              <div class="interval-box">
                <input type="number" v-model="modules?.timing.minInterval" class="interval-input"
                       @change="saveConfig">
                <span>~</span>
                <input type="number" v-model="modules?.timing.maxInterval" class="interval-input"
                       @change="saveConfig">
                <span class="interval-label">秒随机</span>
              </div>
            </div>
          </div>
        </div>

        <div class="module-card">
          <div class="module-header">
            <span class="module-title">进间欢迎</span>
            <label class="checkbox-item">
              <input type="checkbox" v-model="modules?.welcome.enabled" @change="saveConfig">
              <span class="checkbox-custom"></span>
            </label>
          </div>
          <div class="module-body">

            <select class="content-select" v-model="modules?.welcome.id" @change="saveConfig">
              <option :value="item.id" v-for="item in talkList?.welcome">{{ item.name }}</option>
            </select>


            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-volume">音量</span>

                <i class="fas fa-volume-up"></i>

                <input type="range" min="0" max="100" v-model="modules?.welcome.volume" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.welcome.volume }}</span>
              </div>
            </div>
            <div class="slider-row">
              <div class="slider-item">
                <span class="slider-item-tachometer" >语速</span>

                <i class="fas fa-tachometer-alt"></i>
                <input type="range" min="0" max="100" v-model="modules?.welcome.speed" class="slider"
                       @change="saveConfig">
                <span class="slider-value">{{ modules?.welcome.speed - 50 }}</span>
              </div>
            </div>
            <div class="module-footer">
              <span class="interval-label-text">间隔</span>
              <div class="interval-box">
                <input type="number" v-model="modules?.welcome.minInterval" class="interval-input" @change="saveConfig">
                <span>~</span>
                <input type="number" v-model="modules?.welcome.maxInterval" class="interval-input" @change="saveConfig">
                <span class="interval-label">秒随机</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="input-panel">
        <input type="text" class="talk-input" placeholder="输入话术" v-model="talkInput">
        <button class="btn btn-primary btn-insert" @click="insertTalk">
          <i class="fas fa-message-square"></i>
          <span>点击插话</span>
        </button>
        <button class="btn btn-danger btn-mic" :class="{ active: isMicOn }" @click="toggleMic">
          <i :class="isMicOn ? 'fas fa-microphone' : 'fas fa-microphone-slash'"></i>
          <span>{{ isMicOn ? '关闭麦克风' : '麦克风插话' }}</span>
        </button>
        <button class="btn btn-secondary btn-channel" @click="openChannelModal">
          <i class="fas fa-sliders-h"></i>
          <span>声道配置</span>
        </button>
      </div>

      <div v-if="showAddVoiceModal" class="modal-overlay" @click.self="showAddVoiceModal = false">
        <div class="modal-container">
          <div class="modal-wrapper">
            <div class="modal-header">
              <div class="header-icon">
                <i class="fas fa-music"></i>
              </div>
              <h3 class="modal-title">新增音色</h3>
              <button class="modal-close" @click="showAddVoiceModal = false">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row-inline">
                <div class="form-group form-group-short">
                  <label class="form-label">音色名称</label>
                  <input type="text" class="form-input" v-model="newVoiceName" placeholder="请输入音色名称">
                </div>
                <div class="form-group form-group-long">
                  <label class="form-label">选择音色文件</label>
                  <div class="file-input-row">
                    <input type="text" class="file-path-input" v-model="selectedFile.name" readonly
                           placeholder="点击按钮选择">
                    <button class="btn btn-outline-primary file-add-btn" @click="triggerFileInput">
                      <span>添加</span>
                    </button>
                  </div>
                  <input type="file" accept="audio/*" class="file-input-hidden" @change="handleFileSelect">
                </div>
              </div>

              <div class="form-row">
                <label class="form-label">已添加文件</label>
                <div class="files-display-box">
                  <div v-if="!selectedFile?.name" class="empty-state">
                    <i class="fas fa-folder-open"></i>
                    <p>暂无文件</p>
                  </div>
                  <div v-else class="files-list">
                    <div class="file-item">
                      <div class="file-info">
                        <i class="fas fa-file-audio"></i>
                        <div class="file-details">
                          <span class="file-name">{{ selectedFile?.name }}</span>
                          <span class="file-size">{{ formatFileSize(selectedFile?.size) }}</span>
                        </div>
                      </div>
                      <div class="file-actions">
                        <button class="file-play" @click="playFile" :title="playing ? '停止' : '播放试听'">
                          <i :class="playing  ? 'fas fa-stop' : 'fas fa-play'"></i>
                        </button>
                        <button class="file-remove" @click="removeFile" title="删除">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <label class="form-label">分类</label>
                <div class="category-options">
                  <label class="category-btn" :class="{ active: voiceCategory == 'female'}">
                    <input type="radio" name="voiceCategory" v-model="voiceCategory" value="female">
                    <span>女生音色</span>
                  </label>
                  <label class="category-btn" :class="{ active: voiceCategory == 'male' }">
                    <input type="radio" name="voiceCategory" v-model="voiceCategory" value="male">
                    <span>男声音色</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="showAddVoiceModal = false">取消</button>
              <button class="btn btn-primary" @click="addVoice">确定添加</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showVoiceListModal" class="modal-overlay" @click.self="showVoiceListModal = false">
      <div class="modal-container">
        <div class="modal-wrapper">
          <div class="modal-header">
            <div class="header-icon">
              <i class="fas fa-music"></i>
            </div>
            <h3 class="modal-title">{{ currentVoiceListTitle }}</h3>
            <button class="modal-close" @click="showVoiceListModal = false">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="voice-list-container">
              <div v-if="voices[currentVoiceCategory]?.length<=0" class="empty-state">
                <i class="fas fa-music"></i>
                <p>暂无添加的音色</p>
                <button class="btn btn-primary"
                        @click="showVoiceListModal = false; showAddVoiceModal = true;voiceCategory=currentVoiceCategory">
                  去添加音色
                </button>
              </div>
              <div v-else class="voice-grid">
                <div v-for="(voice, index) in voices[currentVoiceCategory]" :key="index" class="voice-card">
                  <div class="voice-card-header">
                    <i class="fas fa-volume-up"></i>
                    <span class="voice-card-name">{{ voice.audio_info.name }}</span>
                  </div>
                  <div class="voice-card-actions">
                    <button class="voice-btn voice-btn-config" @click="openVoiceConfig(voice.audio_info)" title="配置">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button class="voice-btn voice-btn-play" @click="playVoice(voice.audio_info)"
                            :title="playingVoiceId === getVoicePlayKey(voice.audio_info) ? '停止' : '试听'">
                      <i :class="playingVoiceId === getVoicePlayKey(voice.audio_info) ? 'fas fa-stop' : 'fas fa-play'"></i>
                    </button>
                    <button class="voice-btn voice-btn-delete" @click="deleteVoice(voice)" title="删除">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="showVoiceConfigModal" class="modal-overlay" @click.self="showVoiceConfigModal = false">
      <div class="modal-container config-modal">
        <div class="modal-wrapper">
          <div class="modal-header config-header">
            <div class="config-title">
              <i class="fas fa-cog"></i>
              <h3 class="modal-title">{{ configVoice?.name || '音色配置' }}</h3>
            </div>
            <button class="modal-close" @click="showVoiceConfigModal = false">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="config-options">
              <label class="config-option">
                <input type="checkbox" name="anchor" :value="configVoice.name" @change="setConfig"
                       :checked="configVoice.name==voicesConfig?.anchor">
                <span class="option-icon"><i class="fas fa-user-circle"></i></span>
                <span class="option-text">设为主播</span>
              </label>

              <label class="config-option">
                <input type="checkbox" name="keyword" :value="configVoice.name" @change="setConfig"
                       :checked="configVoice.name==voicesConfig?.keyword">
                <span class="option-icon"><i class="fas fa-keyboard"></i></span>
                <span class="option-text">关键词回复</span>
              </label>
              <label class="config-option">
                <input type="checkbox" name="timing" :value="configVoice.name" @change="setConfig"
                       :checked="configVoice.name==voicesConfig?.timing">
                <span class="option-icon"><i class="fas fa-clock"></i></span>
                <span class="option-text">插播报时</span>
              </label>
              <label class="config-option">
                <input type="checkbox" name="welcome" :value="configVoice.name" @change="setConfig"
                       :checked="configVoice.name==voicesConfig?.welcome">
                <span class="option-icon"><i class="fas fa-door-open"></i></span>
                <span class="option-text">进间欢迎</span>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="showChannelModal" class="modal-overlay" @click.self="showChannelModal = false">
      <div class="modal-container channel-modal">
        <div class="modal-wrapper">
          <div class="modal-header">
            <div class="header-icon">
              <i class="fas fa-sliders-h"></i>
            </div>
            <h3 class="modal-title">声道配置</h3>
            <button class="modal-close" @click="showChannelModal = false">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="channel-section">
              <label class="channel-label"><i class="fas fa-headphones"></i>输入声道</label>
              <select v-model="channelConfig.inputDeviceId" class="channel-select">
                <option v-for="device in inputDevices" :key="device.deviceId" :value="device.deviceId">
                  {{ device.label || '未命名设备' }}
                </option>
              </select>
            </div>
            <div class="channel-section">
              <label class="channel-label"><i class="fas fa-volume-up"></i>输出声道</label>
              <select v-model="channelConfig.outputDeviceId" class="channel-select">
                <option v-for="device in outputDevices" :key="device.deviceId" :value="device.deviceId">
                  {{ device.label || '未命名设备' }}
                </option>
              </select>
            </div>
            <div class="channel-section dodge-section">
              <div class="dodge-header">
                <label class="channel-label"><i class="fas fa-volume-down"></i>闪避原音频</label>
                <label class="dodge-switch">
                  <input type="checkbox" v-model="channelConfig.dodgeEnabled">
                  <span class="switch-slider"></span>
                </label>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showChannelModal = false">取消</button>
            <button class="btn btn-primary" @click="saveChannelConfig">确认</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>


import http from "@/utils/http";

import gradioMod from "@/utils/gradio-index"


import {delay, extractChineseCharacters, getRandomInt, getYmdHm, checkAuduiSrc, randomText} from "@/utils/function";

import FloatMenu from "@/components/floatMenu.vue";
let AudioDev, audioText, delAudio, getList, saveAudio, upload,insertVoice

export default {
  name: 'VoiceControl',
  components: {FloatMenu},
  data() {
    return {
      user_name: null,
      keyword_content: null,
      talkList: {},
      live_num: 0,
      voiceAudioText: [],
      voiceAudioList: [],
      insertAudioList: this.$store.state.insertAudioList,
      currentInputDevice: null,
      currentOutDevice: null,
      audioCtx: null,
      voices: {},
      playingVoiceId: null,
      voiceAudio: null,
      playing: false,
      selectedVoice: 'female',
      showAddVoiceModal: false,
      showVoiceListModal: false,
      showVoiceConfigModal: false,
      showChannelModal: false,
      inputDevices: [],
      outputDevices: [],

      currentVoiceCategory: 'female',

      selectedFile: {},
      newVoiceName: '',
      voiceCategory: "female",

      filters: {
        maxChars: 4,
      },

      talkInput: '',
      isMicOn: false,
      isAIEnabled: false,
      playingFileIndex: null,
      currentAudio: null,
    }
  },

  watch: {

    currentInputDevice() {

    },
    modules: {

      handler() {

        this.updateAudio();
      }, deep: true


    },
    currentOutDevice() {
      if (this.audioCtx) {
        this.audioCtx.setSinkId(this.currentOutDevice);
      }
      if (this.$store.state.keywordAudio) {
        this.$store.state.keywordAudio.setSinkId(this.channelConfig?.outputDeviceId);
      }
      if (this.$store.state.welcomeAudio) {
        this.$store.state.welcomeAudio.setSinkId(this.channelConfig?.outputDeviceId);
      }
      if (this.$store.state.timingAudio) {
        this.$store.state.timingAudio.setSinkId(this.channelConfig?.outputDeviceId);
      }

      if (this.$store.state.anchorAudio) {
        this.$store.state.anchorAudio.setSinkId(this.channelConfig?.outputDeviceId);
      }
    },
    showAddVoiceModal(val) {
      if (!val) {
        this.stopCurrentAudio();
      }
    },
    showVoiceListModal(val) {
      if (!val) {
        this.stopVoiceAudio();
      }
    }
  },

  async mounted() {

    const mod = await gradioMod;
    ({ AudioDev, audioText, delAudio, getList, saveAudio, upload ,insertVoice} = mod);


    this.getVoices();
    this.getConfig();
    this.init();

  },
  computed: {
    channelConfig() {
      return this.$store.state.channelConfig;
    },
    configVoice() {

      return this.$store.state.configVoice;
    },

    currentVoiceListTitle() {
      return this.currentVoiceCategory === 'female' ? '女生音色列表' : '男声音色列表'
    },
    modules() {

      return this.$store.state.modules;
    },

    voicesConfig() {
      return this.$store.state.voicesConfig;
    }
  },
  methods: {
    import(){

    },
    updateAudio() {
      if (this.$store.state.keywordAudio) {
        this.$store.state.keywordAudio.volume = this.modules?.keyword.volume / 100;
        if ((1 / 50 * this.modules?.keyword.speed) < 0.07) {
          this.$store.state.keywordAudio.playbackRate = 0.07
        } else {
          this.$store.state.keywordAudio.playbackRate = 1 / 50 * this.modules?.keyword.speed
        }
      }
      if (this.$store.state.timingAudio) {
        this.$store.state.timingAudio.volume = this.modules?.timing.volume / 100;
        if ((1 / 50 * this.modules?.welcome.speed) < 0.07) {
          this.$store.state.timingAudio.playbackRate = 0.07
        } else {
          this.$store.state.timingAudio.playbackRate = 1 / 50 * this.modules?.timing.speed
        }
      }
      if (this.$store.state.welcomeAudio) {
        this.$store.state.welcomeAudio.volume = this.modules?.welcome.volume / 100;
        if ((1 / 50 * this.modules?.welcome.speed) < 0.07) {
          this.$store.state.welcomeAudio.playbackRate = 0.07
        } else {
          this.$store.state.welcomeAudio.playbackRate = 1 / 50 * this.modules?.welcome.speed
        }
      }
      if (this.$store.state.anchorAudio) {
        this.$store.state.anchorAudio.volume = this.modules?.anchor.volume / 100;
        if ((1 / 50 * this.modules?.anchor.speed) < 0.07) {
          this.$store.state.anchorAudio.playbackRate = 0.07
        } else {
          this.$store.state.anchorAudio.playbackRate = 1 / 50 * this.modules?.anchor.speed
        }
      }

      this.$store.commit("setAudios", {
        anchorAudio: this.$store.state.anchorAudio,
        keywordAudio: this.$store.state.keywordAudio,
        timingAudio: this.$store.state.timingAudio,
        welcomeAudio: this.$store.state.welcomeAudio,
      })

    },
    async init() {
      const modules = await this.Db("音色控制配置").find() || {
        anchor: {
          volume: 100,
          speed: 50,
          enabled: false,
          minInterval: 0,
          maxInterval: 0
        },
        keyword: {
          volume: 100,
          speed: 50,
          enabled: false,
          minInterval: 0,
          maxInterval: 0,
        },
        timing: {
          volume: 100,
          speed: 50,
          pitch: 50,
          enabled: false,
          minInterval: 60,
          maxInterval: 180
        },
        welcome: {
          volume: 100,
          speed: 50,
          pitch: 50,
          noise: 0,
          enabled: false,
          minInterval: 60,
          maxInterval: 180
        }
      }
      this.$store.commit("setModules", modules);
      const list = await this.Db("话术管理").select();
      var obj = [];
      list.forEach(v => {
        if (!obj[v.type]) {
          obj[v.type] = [];
        }
        obj[v.type].push(v);
      })
      this.talkList = obj;

    },

    async saveConfig() {
      await this.Db("音色控制配置").delete();
      await this.Db("音色控制配置").add(this.modules);
      this.init();
    },

    async setConfig(e) {
      const checked = e.target.checked
      const name = e.target.name
      const value = e.target.value

      var config = await this.Db("音色配置").find();


      if (!config) {
        await this.Db("音色配置").add({});
        config = await this.Db("音色配置").find();
      }

      if (checked) {
        await this.Db("音色配置").where("id", config.id).update({
          [name]: value
        })
      } else {
        await this.Db("音色配置").where("id", config.id).update({
          [name]: null
        })

      }

      this.getConfig();
    },

    async getConfig() {
      const data = await this.Db("音色配置").find();
      if (data) {
        this.$store.commit("setVoicesConfig", data);
      }

    },

    async getVoices() {

      const res=await http.get("api/audio/getList");
      var voices = {female: [], male: []}
      if(res.code==200){
        const data=res.data;
        console.log(data);
        data.forEach(v=>{
          voices[v.audio_info.type].push(v)
        })
      }


      this.voices = voices;

    },

    async openChannelModal() {
      await this.getAudioDevices()
      this.showChannelModal = true
    },
    async getAudioDevices() {
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          alert('您的浏览器不支持音频设备访问功能，请使用现代浏览器。')
          this.inputDevices = [{deviceId: 'default', label: '默认输入设备'}]
          this.outputDevices = [{deviceId: 'default', label: '默认输出设备'}]

          this.$store.commit("setChannelConfig", {
            inputDeviceId: 'default',
            outputDeviceId: 'default'
          })

          return
        }

        const stream = await navigator.mediaDevices.getUserMedia({audio: true})
        stream.getTracks().forEach(track => track.stop())

        const devices = await navigator.mediaDevices.enumerateDevices()


        this.inputDevices = devices.filter(d => d.kind === 'audioinput')
        this.outputDevices = devices.filter(d => d.kind === 'audiooutput')

        if (this.inputDevices.length === 0) {
          this.inputDevices = [{deviceId: 'default', label: '未检测到输入设备'}]
        }
        if (this.outputDevices.length === 0) {
          this.outputDevices = [{deviceId: 'default', label: '未检测到输出设备'}]
        }

        if (!this.channelConfig.inputDeviceId || !this.inputDevices.find(d => d.deviceId === this.channelConfig.inputDeviceId)) {
          this.$store.commit("setChannelConfig", {
            inputDeviceId: this.inputDevices[0].deviceId
          })
        }
        if (!this.channelConfig.outputDeviceId || !this.outputDevices.find(d => d.deviceId === this.channelConfig.outputDeviceId)) {

          this.$store.commit("setChannelConfig", {
            outputDeviceId: this.outputDevices[0].deviceId
          })

        }
      } catch (error) {
        console.error('获取音频设备失败:', error)
        if (error.name === 'NotAllowedError') {
          alert('请在浏览器权限设置中允许麦克风访问，以便获取音频设备列表。')
        } else if (error.name === 'NotFoundError') {
          alert('未检测到音频设备，请检查您的音频设备是否正常连接。')
        } else {
          alert('获取音频设备列表失败: ' + error.message)
        }
        this.inputDevices = [{deviceId: 'default', label: '默认输入设备'}]
        this.outputDevices = [{deviceId: 'default', label: '默认输出设备'}]
        this.channelConfig.inputDeviceId = 'default'
        this.channelConfig.outputDeviceId = 'default'
      }
    },

    async insertTalk() {
      this.getConfig();
      if (this.talkInput.trim()) {
        if (!this.voicesConfig?.anchor) {
          this.$dialog.tips({message: "请先设置主播!", type: "error"})
          return;
        }
        if (!this.$store.state.isAIEnabled) {
          this.$dialog.tips({
            message: "未开启AI主播",
            type: "error"
          })
          return;
        }
        this.$dialog.loading({text: "正在插话中.."});
        this.insertAudioList.push(await insertVoice(this.talkInput, "anchor"))

        this.$store.commit("setInsertAudioList",this.insertAudioList);

        this.$dialog.closeLoading();
        this.$dialog.tips({
          message: "插话成功",
        })

        this.talkInput = ''

      }
    },
    // 插入


    async toggleMic() {
      this.isMicOn = !this.isMicOn

      if (!this.audioCtx) this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();

      if (this.isMicOn) {
        // 获取麦克风流
        const stream = await navigator.mediaDevices.getUserMedia({audio: true});
        // 创建音频源
        const source = this.audioCtx.createMediaStreamSource(stream);
        // 音量节点（防止啸叫）
        const gainNode = this.audioCtx.createGain();
        gainNode.gain.value = 0.6;


        this.updateAudio();
        // 链路：麦克风 -> 音量 -> 扬声器实时播放
        source.connect(gainNode);
        gainNode.connect(this.audioCtx.destination);

      } else {
        if (this.audioCtx) this.audioCtx.close();
        this.audioCtx = null;
      }

      console.log('麦克风状态:', this.isMicOn ? '开启' : '关闭')
    },


    //检测是否可以开启
    checkEnabled(type) {
      switch (type) {
        case "anchor":
          var text = "主播";
          break;
        case "keyword":
          var text = "关键词";
          break;
        case "timing":
          var text = "插播报时";
          break;
        case "welcome":
          var text = "进间欢迎";
          break;
      }

      if (!this.voicesConfig[type] && this.modules[type]?.enabled) {
        this.$store.state.isAIEnabled = false;
        return `未设置${text}音色`;
      } else if (this.modules[type]?.enabled && (this.modules[type]?.id <= 0 || this.modules[type]?.id == null)) {
        this.$store.state.isAIEnabled = false;
        return `未设置${text}话术`;
      }

      return "";

    },
    async toggleAIReply() {


      if (!this.$store.state.isAIEnabled) {
        this.$dialog.tips({
          message: "请先开启AI主播",
          type: "error"
        })
        return;
      }

      if (!this.$store.state.liveWs) {
        this.$dialog.tips({
          message: "请先到直播账号管理连接直播间",
          type: "error"
        })
        return;
      }

      if(!this.voicesConfig?.keyword){
        this.$dialog.tips({
          message: "未设置主播（关键词）音色",
          type: "error"
        })
        return;
      }


      this.$store.commit("setAIReplyEnabled", !this.$store.state.isAIReplyEnabled);

      if (this.$store.state.isAIReplyEnabled) {
        const confirm = await this.$dialog.confirm({
          title: '温馨提示',
          message: '此功能开启后，关键词回复将会失效，是否继续开启？'
        }).catch(() => false);
        if (confirm !== false) {
          this.$dialog.tips({
            message: "智能回复开启成功",
            type: "success"
          })
        } else {
          this.$store.commit("setAIReplyEnabled", false);
        }


      } else {
        this.$dialog.tips({
          message: "智能回复关闭成功",
          type: "success"
        })
      }

    },


    /*开关ai主播*/
    async toggleAI() {
      if(!this.$store.state.ttsStatus){
        this.$dialog.tips({
          message: "正在启动中...",
          type: "warning"
        })
        return;
      }

      if (!this.$store.state.userInfo?.platform) {
        this.$dialog.tips({
          message: "请先登录一个主播账号",
          type: "error"
        })
        return;
      }



      this.$store.commit("setAIEnabled", !this.$store.state.isAIEnabled);
      if (this.$store.state.isAIEnabled) {
        // 开启成功

        var error = this.checkEnabled("anchor")
        if (error) {
          this.$dialog.tips({
            message: error,
            type: "error"
          })
          this.$store.commit("setAIEnabled",false);

          return;
        }

        var error = this.checkEnabled("keyword")
        if (error) {
          this.$dialog.tips({
            message: error,
            type: "error"
          })
          this.$store.commit("setAIEnabled",false);

          return;
        }

        var error = this.checkEnabled("timing")
        if (error) {
          this.$dialog.tips({
            message: error,
            type: "error"
          })
          this.$store.commit("setAIEnabled",false);

          return;
        }

        var error = this.checkEnabled("welcome")
        if (error) {
          this.$dialog.tips({
            message: error,
            type: "error"
          })
          this.$store.commit("setAIEnabled",false);

          return;
        }



        //主播话术
        this.anchorAi();
        this.timingAi();
        this.keywordAi();
        this.welcomeAi();
        // 关键词回复
      } else {
        // 停止所有音频
        this.$store.commit("setAIReplyEnabled", false)
        this.stopAll();

      }
    },

    async metKeyword(data){
      if(this.$store.state.isAIReplyEnabled){
        const res = await http.post("api/voice/work", {
          content: data.content,
        })
        if (res.code == 200) {
          return res.data
        }
      }else if(this.$store.state.isAIEnabled){
        let result = await this.Db("话术列表")
            .whereMatch("keyword", data.content) // 关键词匹配
            .where("talk_id", this.modules.keyword.id)
            .find();

        if (result) {
          console.log("触发关键词")

          if (this.voicesConfig?.keyword) {
            var text = result.content;
            var name = extractChineseCharacters(data.nickname);
            if (name) {
              if (this.filters.maxChars) {
                name = name.slice(0, parseInt(this.filters.maxChars));
              }
              text = text.replaceAll("{时间}", getYmdHm()).replaceAll("{人数}", this.live_num || 0).replaceAll("{名字}", name);

              return  text;
            }

          }
        }

      }


      return  false;


    },

    async keywordAi() {
      if (this.$store.state.isAIEnabled && this.modules?.keyword.enabled && this.modules.keyword.id > 0) {
        const timer = getRandomInt(this.modules.keyword.minInterval, this.modules.keyword.maxInterval) * 1000;
        const contentData=this.$store.state.liveData.messageData;

        if (contentData.content != this.$store.state.liveKeyword) {
          const res = await this.metKeyword(contentData)
          if (res) {

            this.$store.commit("setLiveKeyword",contentData.content)
            if (!checkAuduiSrc(this.$store.state.keywordAudio)) {
              const blob = await insertVoice(res, "keyword");
              this.keyword_content = null;
              this.$store.state.keywordAudio.src = blob;
            }
          }
        }
        await delay(timer)
        this.keywordAi();
        return
      }
      await delay(1000)
      this.keywordAi();


    },
    async welcomeAi() {
      if (this.$store.state.isAIEnabled && this.modules?.welcome.enabled && this.modules.welcome.id > 0) {
        const timer = getRandomInt(this.modules.welcome.minInterval, this.modules.welcome.maxInterval) * 1000;
        if (this.$store.state.liveData.room_nickname) {
          const res = await this.setWords(this.modules.welcome?.id);
          if (res) {
            var text = res[getRandomInt(0, res.length - 1)].content;
            text = text.replaceAll("{时间}", getYmdHm()).replaceAll("{人数}", this.$store.state.liveData.userCount || 0).replaceAll("{名字}", this.$store.state.liveData.room_nickname);
            this.$store.commit("setLiveData",{
              type:"room_nickname",
              data:""
            });
            if (!checkAuduiSrc(this.$store.state.welcomeAudio)) {
              const blob = await insertVoice(text, "welcome");
              this.$store.state.welcomeAudio.src = blob;
            }
          }
        }
        await delay(timer)

        this.welcomeAi();

        return
      }

      await delay(1000)
      this.welcomeAi();


    },

    /*主播话术*/
    async anchorAi() {

      if (!this.$store.state.isAIEnabled) {

        return;
      }

      this.$store.commit("setAiPlayStatus", false)


      const anchorId = this.modules?.anchor.id;
      this.voiceAudioText = [];
      this.voiceAudioList = [];

      if (this.modules?.anchor.enabled) {
        // 开始创建话术
        this.voiceAudioText = await this.voiceAudioText.concat(await this.setWords(anchorId))
        if (this.voiceAudioText.length <= 0) {
          this.$dialog.tips({
            message: "没有话术内容，请添加话术",
            type: "error"
          })
          this.$store.state.isAIEnabled = false;
          return;
        }
        this.createVoiceList();
        this.$dialog.loading({text: "AI预热中..."});
        while (true) {
          if (this.voiceAudioList.length >= 1) {
            this.$dialog.closeLoading();
            this.$dialog.tips({message: "AI主播已开启"})
            this.playVoicePlay();
            break;
          }
          await delay(1000)
        }

      }


    },
    /*报时*/
    async timingAi() {
      if (this.$store.state.isAIEnabled && this.modules?.timing.enabled && this.modules.timing.id > 0) {
        // 报时
        const timer = getRandomInt(this.modules.timing.minInterval, this.modules.timing.maxInterval) * 1000;
        await delay(timer)
        const res = await this.setWords(this.modules.timing?.id);
        if (res) {
          var text = res[getRandomInt(0, res.length - 1)].content;
          text = text.replaceAll("{时间}", getYmdHm()).replaceAll("{人数}", this.$store.state.liveData.userCount || 0);

          if (!checkAuduiSrc(this.$store.state.timingAudio)) {
            const blob = await insertVoice(text, "timing");
            this.$store.state.timingAudio.src = blob;
          }

        }


      }

    },

    async stopAll() {
      if (this.$store.state.anchorAudio) {
        this.$store.state.anchorAudio.pause();
      }
      if (this.$store.state.welcomeAudio) {
        this.$store.state.welcomeAudio.pause();
      }
      if (this.$store.state.keywordAudio) {
        this.$store.state.keywordAudio.pause();
      }
      if (this.$store.state.timingAudio) {
        this.$store.state.timingAudio.pause();
      }
      // 设置话术为空
      this.voiceAudioText = [];
      // 设置音频为空
      this.voiceAudioList = [];
      this.$dialog.tips({message: "AI主播已关闭"});
    },

    async setWords(talk_id) {
      if (this.$store.state.isAIEnabled) {
        const list = await this.Db("话术列表").where("talk_id", talk_id).select();
        const contentList = await this.createText(list);
        return contentList;
      }

    },
    createText(list) {
      console.log("list", list)
      const arr = [];
      list.forEach(async v => {
        var content = "";
        if (v.rewrites && v.rewrites.length > 0) {
          content = v.rewrites[Math.floor(Math.random() * v.rewrites.length)]
        } else {
          content = v.content;
        }
        content = randomText(content);
        arr.push({
          type: v.talk_type,
          content,
        });
      })

      return arr;

    },
    async handleFileSelect(event) {
      const files = Array.from(event.target.files)
      if (files.length > 0) {

        this.stopCurrentAudio();

        const blobUrl = URL.createObjectURL(files[0]);
        const audio = new Audio();
        audio.onloadedmetadata = () => {
          URL.revokeObjectURL(blobUrl)
          if (audio.duration < 5 || audio.duration > 60) {
            this.$dialog.tips({message: "请上传5s-60s的音频", type: "error"})
            return false;
          }
          this.selectedFile = files[0];

        }
        audio.src = blobUrl;


      }
      event.target.value = ''
    },
    triggerFileInput() {
      const fileInput = document.querySelector('.file-input-hidden')
      if (fileInput) {
        fileInput.click()
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    removeFile() {
      this.stopCurrentAudio();

      this.selectedFile = {};

    },
    stopCurrentAudio() {
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }
      this.playing = false;
    },
    stopVoiceAudio() {
      if (this.voiceAudio) {
        this.voiceAudio.pause();
        this.voiceAudio = null;
      }
      this.playingVoiceId = null;
    },
    getVoicePlayKey(voice) {
      return voice?.file_path || '';
    },
    playFile() {

      const file = this.selectedFile;

      if (this.playing == false) {
        this.stopCurrentAudio();

        this.playing = true;
        const url = URL.createObjectURL(file)
        const audio = new Audio(url)
        this.currentAudio = audio;
        this.playing = true;

        audio.play().catch(err => {
          this.playing = false;

          console.error('播放失败:', err)
          this.stopCurrentAudio();
          alert('播放失败，请确保已允许音频播放')
        });

        audio.onended = () => {
          this.stopCurrentAudio();
        };
      } else {
        this.stopCurrentAudio();

      }
    },
    async addVoice() {
      if (!this.selectedFile?.name) {
        this.$dialog.tips({message: '请先选择音色文件', type: 'error'})

        return
      }
      if (!this.newVoiceName.trim()) {
        this.$dialog.tips({message: '请输入音色名称', type: 'error'})
        return
      }


      const form = new FormData();
      form.append("files", this.selectedFile);


      const res = await upload(form);

      if (!res) {
        this.$dialog.tips({message: "上传音频失败", type: "error"})
        return;
      }

      this.$dialog.loading({text: "上传中.."})
      const rel = await saveAudio(this.newVoiceName, res[0]);

      if (rel) {
        const rel=await http.post("api/audio/add",{
          "type": this.voiceCategory,
          "name": this.newVoiceName,
          "file_path": res[0]
        });


        if (rel.code==200) {
          this.showAddVoiceModal = false
          this.selectedFile = {}
          this.newVoiceName = ''
          this.voiceCategory = 'female';
          this.$dialog.tips({message: "添加音色成功", type: "success"})
          this.$dialog.closeLoading();
          this.getVoices();
          return;

        }

        this.$dialog.tips({message: "添加音色失败,请重试!", type: "error"})

        return;

      }

      this.$dialog.tips({message: "音色保存失败!", type: "error"})

    },
    openVoiceList(category) {
      this.currentVoiceCategory = category
      this.showVoiceListModal = true
    },

    async createVoiceList() {

      if (this.$store.state.isAIEnabled) {
        const blob = await audioText(this.voiceAudioText.shift().content, this.voicesConfig?.anchor);
        this.voiceAudioList.push(blob);
        if (this.voiceAudioText.length - 5 <= 0) {
          this.voiceAudioText = await this.voiceAudioText.concat(await this.setWords(this.modules?.anchor.id))
        }
        this.createVoiceList();
      }
    },
    //检测是有资源

    //清空资源
    clearAudio(audio) {
      if (!audio) return;
      audio.pause();           // 先停止
      audio.src = '';          // 赋值空
      audio.load();            // 强制浏览器刷新
      audio.onended = null;    // 清空事件

    },
    //开始播放
    async playVoicePlay() {

      if (!this.$store.state.isAIEnabled) {

        return;
      }
      await this.updateAudio();


      console.log(this.insertAudioList.length);

      if (this.insertAudioList.length > 0) {
        const blob = this.insertAudioList.shift();
        this.$store.commit("setInsertAudioList",this.insertAudioList);
        this.$store.state.anchorAudio.src = blob
        this.$store.state.anchorAudio.onended = null;
        this.$store.state.anchorAudio.play();
        this.$store.state.anchorAudio.onended = () => {
          this.playVoicePlay();
        }
        return;
      }


      const blob = this.voiceAudioList.shift();
      this.$store.state.anchorAudio.src = blob
      this.$store.state.anchorAudio.onended = null;
      this.$store.state.anchorAudio.play();
      this.$store.state.anchorAudio.onended = () => {
        //检测关键
        this.$store.state.anchorAudio.onended = null;

        console.log(this.$store.state.keywordAudio);

        //关键词检测
        if (checkAuduiSrc(this.$store.state.keywordAudio)) {
          this.$store.state.keywordAudio.onended = null;
          this.$store.state.keywordAudio.play().catch(() => {
            //播放错误
            this.clearAudio(this.$store.state.keywordAudio)
            this.playVoicePlay();
          });

          this.$store.state.keywordAudio.onended = () => {
            this.clearAudio(this.$store.state.keywordAudio)
            this.playVoicePlay();
          }
          if (this.channelConfig.dodgeEnabled) {
            return;
          }
        }
        //检测欢迎
        if (checkAuduiSrc(this.$store.state.welcomeAudio)) {
          this.user_name = null;
          this.$store.state.welcomeAudio.onended = null;
          this.$store.state.welcomeAudio.play().catch(() => {
            //播放错误
            this.clearAudio(this.$store.state.welcomeAudio)
            this.playVoicePlay();
          });

          this.$store.state.welcomeAudio.onended = () => {
            this.clearAudio(this.$store.state.welcomeAudio)
            this.playVoicePlay();
          }
          if (this.channelConfig.dodgeEnabled) {

            return;
          }
        }
        //检测报时
        if (checkAuduiSrc(this.$store.state.timingAudio)) {
          this.$store.state.timingAudio.onended = null;
          this.$store.state.timingAudio.play().catch(() => {
            //播放错误
            this.clearAudio(this.$store.state.timingAudio)
            this.playVoicePlay();
            this.timingAi();
          });

          this.$store.state.timingAudio.onended = () => {
            this.clearAudio(this.$store.state.timingAudio)
            this.playVoicePlay();
            this.timingAi();

          }
          if (this.channelConfig.dodgeEnabled) {

            return;
          }
        }

        setTimeout(() => {
          this.playVoicePlay();
        }, getRandomInt(this.modules?.anchor.minInterval, this.modules?.anchor.maxInterval) * 1000)
      }

    },
    // 试听
    playVoice(voice) {
      if (voice.file_path) {
        const key = this.getVoicePlayKey(voice);
        if (this.playingVoiceId === key) {
          this.stopVoiceAudio();
          return;
        }

        this.stopCurrentAudio();
        this.stopVoiceAudio();
        this.playingVoiceId = key;
        let audio = AudioDev(voice.file_path);
        audio.onended = () => {
          this.stopVoiceAudio();
        }
        this.voiceAudio = audio;
        audio.play().catch(err => {
          this.stopVoiceAudio();
          this.$dialog.tips({
            message: "播放失败",
            type: "error"
          })
        })


      }
    },
    // 删除音色
    async deleteVoice(voice) {

      const confirm = await this.$dialog.confirm({
        title: "确认删除",
        message: "确认删除这个音色吗?",
        okText: "删除",
        cancelText: "取消"
      }).catch(async () => false);
      if (confirm !== false) {

        const res=await http.post("api/audio/delete",{id:voice.id})
        if (res) {

          delAudio(voice.audio_info.file_path,voice.audio_info.name);
          this.$dialog.tips({message: "删除音色成功", type: "success"});
          this.showVoiceConfigModal = false
          this.getVoices();
          return;
        }
        this.$dialog.tips({message: "删除音色失败", type: "error"})
      }

    },
    openVoiceConfig(voice) {
      const configVoice = JSON.parse(JSON.stringify(voice))

      this.$store.commit("setConfigVoice", configVoice)

      this.showVoiceConfigModal = true
    },
    async saveVoiceConfig() {
      if (this.configVoice) {

        const res = await http.post("api/voice/update", this.configVoice)

        if (res.code == 200) {
          this.$dialog.tips({
            message: res.msg,
            type: "success"
          })
          this.showVoiceConfigModal = false
          this.getVoices();

          return;
        }
        this.$dialog.tips({
          message: res.msg,
          type: "error"
        })

        return;
      }

      this.$dialog.tips({
        message: "读取配置失败",
        type: "error"
      })

    },
    saveChannelConfig() {
      console.log('声道配置保存:', this.channelConfig)
      console.log(this.channelConfig);


      this.currentOutDevice = this.channelConfig.outputDeviceId
      this.currentInputDevice = this.channelConfig.inputDeviceId
      this.showChannelModal = false
      this.$dialog.tips({
        message: "声道配置保存成功",
      })
    },

  }

}
</script>

<style scoped>
.voice-control-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.btn {
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.7) 0%, rgba(80, 80, 80, 0.7) 100%);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.3);
  box-shadow: 0 4px 15px rgba(170, 170, 170, 0.15);
}

.btn-primary:hover {
  background: linear-gradient(135deg, rgba(120, 120, 120, 0.8) 0%, rgba(100, 100, 100, 0.8) 100%);
  border-color: rgba(170, 170, 170, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(170, 170, 170, 0.2);
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.7) 0%, rgba(75, 85, 99, 0.7) 100%);
  border-color: rgba(156, 163, 175, 0.7);
}

.btn-danger {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.6) 0%, rgba(220, 38, 38, 0.6) 100%);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(248, 113, 113, 0.5);
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.btn-danger:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.7) 0%, rgba(220, 38, 38, 0.7) 100%);
  border-color: rgba(248, 113, 113, 0.7);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.btn-danger.active {
  background: linear-gradient(135deg, rgba(220, 38, 38, 0.7) 0%, rgba(185, 28, 28, 0.7) 100%);
  border-color: rgba(248, 113, 113, 0.7);
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.5);
}

.voice-presets {
  display: flex;
  gap: 10px;
}

.preset-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, rgba(70, 70, 70, 0.7) 0%, rgba(50, 50, 50, 0.7) 100%);
  border: 1px solid rgba(170, 170, 170, 0.3);
  color: rgba(170, 170, 170, 0.9);
  padding: 10px 18px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.voice-count {
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.8) 0%, rgba(80, 80, 80, 0.8) 100%);
  color: rgba(170, 170, 170, 0.9);
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 12px;
  min-width: 22px;
  text-align: center;
  font-weight: 600;
}

.preset-btn:hover {
  background: linear-gradient(135deg, rgba(80, 80, 80, 0.8) 0%, rgba(60, 60, 60, 0.8) 100%);
  border-color: rgba(170, 170, 170, 0.5);
  transform: translateY(-2px);
}

.preset-btn.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(99, 102, 241, 0.6) 100%);
  border-color: rgba(167, 139, 250, 0.7);
  color: #c4b5fd;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.preset-btn.ai-btn {
  background: linear-gradient(135deg, #22d3ee 0%, #06b6d4 50%, #0891b2 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(34, 211, 238, 0.3);
  border-color: rgba(34, 211, 238, 0.4);
}

.preset-btn.ai-btn:hover {
  background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 50%, #0284c7 100%);
  box-shadow: 0 6px 20px rgba(34, 211, 238, 0.4);
  transform: translateY(-2px);
}

.preset-btn.ai-btn.active {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  border-color: rgba(16, 185, 129, 0.5);
}

.preset-btn.ai-reply-btn {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
  border-color: rgba(139, 92, 246, 0.4);
}

.preset-btn.ai-reply-btn:hover {
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 50%, #7c3aed 100%);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
  transform: translateY(-2px);
}

.preset-btn.ai-reply-btn.active {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  border-color: rgba(16, 185, 129, 0.5);
}

.preset-btn-male {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.7) 0%, rgba(37, 99, 235, 0.7) 100%);
  border-color: rgba(147, 197, 253, 0.6);
  color: #ffffff;
}

.preset-btn-male:hover {
  background: linear-gradient(135deg, rgba(147, 197, 253, 0.7) 0%, rgba(59, 130, 246, 0.7) 100%);
  border-color: rgba(191, 219, 254, 0.6);
}

.preset-btn-male.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(99, 102, 241, 0.6) 100%);
  border-color: rgba(167, 139, 250, 0.7);
  color: #c4b5fd;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.module-card {
  background: linear-gradient(135deg, rgba(50, 50, 50, 0.9) 0%, rgba(40, 40, 40, 0.9) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.25);
  overflow: hidden;
}

.module-header {
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(60, 60, 60, 0.5);
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.module-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.role-select {
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  background: rgba(60, 60, 60, 0.5);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  padding: 6px 28px 6px 12px;
  margin: 0;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23aaaaaa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  transition: all 0.3s ease;
}

.role-select:hover {
  background: rgba(70, 70, 70, 0.6);
  border-color: rgba(170, 170, 170, 0.5);
}

.role-select:focus {
  background: rgba(70, 70, 70, 0.6);
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.2);
}

.role-select option {
  background: #333;
  color: rgba(170, 170, 170, 0.9);
  padding: 8px 12px;
}

.module-input {
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  padding: 5px 10px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 12px;
  width: 100px;
}

.module-input::placeholder {
  color: rgba(170, 170, 170, 0.4);
}

.voice-btn {
  background: rgba(170, 170, 170, 0.1);
  border: none;
  color: rgba(170, 170, 170, 0.9);
  padding: 5px 12px;
  border-radius: 5px;
  font-size: 11px;
  cursor: pointer;
}

.voice-btn:hover {
  background: rgba(170, 170, 170, 0.2);
}

.module-body {
  padding: 16px;
}

.content-select {
  width: 100%;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  padding: 8px 12px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 12px;
  margin-bottom: 14px;
  cursor: pointer;
}

.slider-row {
  gap: 10px;

  margin-bottom: 10px;
}

.slider-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: rgba(60, 60, 60, 0.6);
  border-radius: 6px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.slider-item-tachometer,.slider-item-volume{
  font-size: 12px;
  white-space: nowrap;
}
.slider-item i {
  color: rgba(170, 170, 170, 0.7);
  width: 18px;
  font-size: 13px;
}

.slider {
  width: 100%;
  flex: 1;
  height: 6px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(80, 80, 80, 0.5);
  border-radius: 3px;
  outline: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: linear-gradient(135deg, #888 0%, #666 100%);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(170, 170, 170, 0.3);
}

.slider-value {
  color: rgba(170, 170, 170, 0.9);
  font-size: 11px;
  font-weight: 500;
  text-align: right;
}

.module-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  margin-top: 6px;
  border-top: 1px solid rgba(80, 80, 80, 0.5);
  flex-wrap: wrap;
  gap: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
  padding: 6px 12px;
  background: transparent;
  border-radius: 8px;
  border: none;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item:hover {
  background: transparent;
}

.checkbox-item input[type="checkbox"] {
  display: none;
}

.checkbox-item .checkbox-custom {
  width: 36px;
  height: 20px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border-radius: 10px;
  position: relative;
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item .checkbox-custom::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  border-radius: 50%;
  top: 1px;
  left: 1px;
  box-shadow: 0 2px 6px rgba(139, 92, 246, 0.4);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
  border-color: rgba(139, 92, 246, 0.5);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom::before {
  left: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
}

.interval-label-text {
  color: rgba(170, 170, 170, 0.7);
  font-size: 12px;
  margin-right: 10px;
  white-space: nowrap;
}

.interval-box {
  display: flex;
  align-items: center;
  gap: 6px;
}

.interval-input {
  width: 48px;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 5px;
  padding: 4px 6px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 11px;
  text-align: center;
  transition: all 0.3s ease;
}

.interval-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
}

.interval-label {
  color: rgba(170, 170, 170, 0.7);
  font-size: 11px;
}

.takeover-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(100, 100, 100, 0.3);
  border: 1px solid rgba(170, 170, 170, 0.3);
  color: rgba(170, 170, 170, 0.9);
  padding: 4px 10px;
  border-radius: 5px;
  font-size: 10px;
  cursor: pointer;
}

.takeover-btn.active {
  background: rgba(139, 92, 246, 0.4);
  border-color: rgba(167, 139, 250, 0.5);
  color: #c4b5fd;
}


.bottom-row {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(145deg, rgba(50, 50, 50, 0.8) 0%, rgba(40, 40, 40, 0.8) 100%);
  border: 1px solid rgba(70, 70, 70, 0.5);
  border-radius: 14px;
  padding: 5px 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.filter-section {
  display: flex;
  gap: 20px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-label {
  color: rgba(170, 170, 170, 0.9);
  font-size: 13px;
  font-weight: 600;
  white-space: pre-wrap;
  text-align: center;
  line-height: 1.4;
}

.bottom-divider {
  width: 1px;
  height: 36px;
  background: rgba(80, 80, 80, 0.5);
}

.delay-section {
  flex-shrink: 0;
}

.max-chars-box {
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(170, 170, 170, 0.7);
  font-size: 12px;
}

.char-input {
  width: 48px;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  padding: 6px 8px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 12px;
  text-align: center;
  transition: all 0.2s ease;
}

.char-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.2);
}

.delay-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(60, 60, 60, 0.5);
}

.delay-label {
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  font-size: 13px;
  min-width: 32px;
}

.delay-input {
  width: 58px;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  padding: 6px 8px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 12px;
  text-align: center;
  transition: all 0.2s ease;
}

.delay-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.2);
}

.delay-box span:not(.delay-label):not(.delay-unit) {
  color: rgba(170, 170, 170, 0.7);
  font-weight: 500;
  font-size: 12px;
}

.delay-unit {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.7);
  font-weight: 600;
}

.delay-divider {
  color: rgba(170, 170, 170, 0.3);
  font-weight: 300;
  font-size: 16px;
}

.ai-filter-box {
  display: flex;
  align-items: center;
}

.ai-checkbox {
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

.input-panel {
  display: flex;
  gap: 12px;
}

.talk-input {
  flex: 1;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  transition: all 0.3s ease;
}

.talk-input::placeholder {
  color: rgba(170, 170, 170, 0.5);
}

.talk-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.btn-insert,
.btn-mic,
.btn-channel {
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-danger.btn-mic {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.7) 0%, rgba(220, 38, 38, 0.7) 100%);
  border-color: rgba(248, 113, 113, 0.6);
  color: #ffffff;
}

.btn-danger.btn-mic:hover {
  background: linear-gradient(135deg, rgba(248, 113, 113, 0.7) 0%, rgba(239, 68, 68, 0.7) 100%);
}

.btn-primary.btn-insert {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.7) 0%, rgba(22, 163, 74, 0.7) 100%);
  border-color: rgba(74, 222, 128, 0.6);
  color: #ffffff;
}

.btn-primary.btn-insert:hover {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.7) 0%, rgba(34, 197, 94, 0.7) 100%);
}

.btn-primary.btn-add-voice {
  background: linear-gradient(135deg, rgba(249, 115, 22, 0.7) 0%, rgba(234, 88, 12, 0.7) 100%);
  border-color: rgba(251, 146, 60, 0.6);
  color: #ffffff;
}

.btn-primary.btn-add-voice:hover {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.7) 0%, rgba(249, 115, 22, 0.7) 100%);
}

.channel-section {
  margin-bottom: 20px;
}

.channel-label {
  display: block;
  margin-bottom: 8px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 600;
  font-size: 13px;
}

.channel-label i {
  margin-right: 6px;
}

.channel-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.channel-select:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.15);
}

.channel-slider {
  width: 100%;
  height: 6px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(80, 80, 80, 0.5);
  border-radius: 3px;
  outline: none;
}

.channel-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 6px rgba(139, 92, 246, 0.4);
}

.channel-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}

.dodge-section {
  background: rgba(60, 60, 60, 0.5);
  border-radius: 12px;
  padding: 16px;
  margin-top: 10px;
}

.dodge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dodge-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.dodge-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 24px;
}

.switch-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: linear-gradient(135deg, #a78bfa 0%, #c4b5fd 100%);
  transition: 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(139, 92, 246, 0.4);
}

.dodge-switch input:checked + .switch-slider {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(34, 211, 238, 0.4) 100%);
}

.dodge-switch input:checked + .switch-slider:before {
  transform: translateX(20px);
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
}

.dodge-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dodge-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dodge-label {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

.dodge-n-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed rgba(170, 170, 170, 0.2);
}

.dodge-n-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.dodge-n-label {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 600;
}

.dodge-n-controls {
  padding-left: 8px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-container {
  width: 100%;
  max-width: 720px;
  padding: 20px;
}

.modal-wrapper {
  background: linear-gradient(180deg, rgba(45, 45, 45, 0.98) 0%, rgba(35, 35, 35, 0.98) 100%);
  border-radius: 24px;
  box-shadow: 0 30px 60px rgba(170, 170, 170, 0.1), 0 0 0 1px rgba(170, 170, 170, 0.2);
  overflow: hidden;
  border: 1px solid rgba(170, 170, 170, 0.2);
  backdrop-filter: blur(20px);
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px;
  background: rgba(170, 170, 170, 0.15);
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.header-icon {
  width: 40px;
  height: 40px;
  background: rgba(170, 170, 170, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(170, 170, 170, 0.9);
  font-size: 20px;
}

.modal-title {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.modal-close {
  background: rgba(170, 170, 170, 0.2);
  border: 1px solid rgba(170, 170, 170, 0.3);
  font-size: 18px;
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.2s;
}

.modal-close:hover {
  background: rgba(170, 170, 170, 0.3);
  border-color: rgba(170, 170, 170, 0.5);
  color: rgba(170, 170, 170, 0.9);
}

.modal-body {
  padding: 24px;
}

.form-row {
  margin-bottom: 20px;
}

.form-row:last-of-type {
  margin-bottom: 0;
}

.form-row-inline {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-row-inline .form-group {
  flex: 1;
}

.form-row-inline .form-group-short {
  flex: 0.8;
}

.form-row-inline .form-group-long {
  flex: 1.5;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 10px;
}

.form-input {
  width: 100%;
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 12px;
  padding: 14px 16px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  box-sizing: border-box;
  transition: all 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.15);
}

.file-input-row {
  display: flex;
  gap: 10px;
}

.file-path-input {
  flex: 1;
  background: rgba(40, 40, 40, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
}

.file-path-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
}

.file-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: 2px dashed rgba(170, 170, 170, 0.4);
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.9);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.file-add-btn:hover {
  background: rgba(170, 170, 170, 0.15);
  border-color: rgba(170, 170, 170, 0.6);
  border-style: solid;
}

.file-input-hidden {
  display: none;
}

.files-display-box {
  background: rgba(50, 50, 50, 0.8);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 12px;
  min-height: 180px;
  max-height: 180px;
  padding: 16px;
  overflow-y: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(170, 170, 170, 0.9);
}

.empty-state i {
  font-size: 36px;
  margin-bottom: 8px;
  opacity: 0.5;
  color: rgba(170, 170, 170, 0.7);
}

.empty-state p {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.7);
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(50, 50, 50, 0.8);
  padding: 12px 14px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(139, 92, 246, 0.2);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.file-info i {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.8) 0%, rgba(80, 80, 80, 0.8) 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(170, 170, 170, 0.9);
  font-size: 16px;
}

.file-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.file-size {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.6);
}

.file-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.file-play {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #22c55e;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.file-play:hover {
  background: rgba(34, 197, 94, 0.2);
  transform: scale(1.1);
}

.file-remove {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.file-remove:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: scale(1.1);
}

.category-options {
  display: flex;
  gap: 14px;
}

.category-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background: rgba(170, 170, 170, 0.1);
  border: 2px solid rgba(170, 170, 170, 0.25);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.8);
}

.category-btn input {
  display: none;
}

.category-btn.active {
  background: rgba(170, 170, 170, 0.2);
  border-color: rgba(170, 170, 170, 0.5);
  color: rgba(170, 170, 170, 0.95);
}

.category-btn:hover {
  border-color: rgba(170, 170, 170, 0.4);
  background: rgba(170, 170, 170, 0.15);
}

.category-btn.active:hover {
  border-color: rgba(170, 170, 170, 0.6);
  background: rgba(170, 170, 170, 0.25);
}

.category-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #666;
  border-radius: 50%;
  position: relative;
  transition: all 0.2s;
}

.category-item input:checked + .category-custom {
  border-color: rgba(170, 170, 170, 0.6);
  background: rgba(100, 100, 100, 0.8);
}

.category-item input:checked + .category-custom::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #aaa;
  border-radius: 50%;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid rgba(170, 170, 170, 0.3);
}

.voice-list-container {
  min-height: 280px;
  max-height: 280px;
  overflow-y: auto;
}

.voice-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.voice-card {
  background: rgba(50, 50, 50, 0.95);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 14px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.voice-card:hover {
  border-color: rgba(170, 170, 170, 0.4);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
}

.voice-card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.voice-card-header i {
  width: 48px;
  height: 48px;
  background: rgba(170, 170, 170, 0.3);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(170, 170, 170, 0.9);
  font-size: 20px;
}

.voice-card-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
  text-align: center;
}

.voice-card-info {
  font-size: 11px;
  color: rgba(170, 170, 170, 0.7);
}

.voice-card-actions {
  display: flex;
  gap: 8px;
}

.voice-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.voice-btn-config {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.6) 0%, rgba(37, 99, 235, 0.6) 100%);
  color: #ffffff;
  border: 1px solid rgba(147, 197, 253, 0.5);
}

.voice-btn-config:hover {
  background: linear-gradient(135deg, rgba(147, 197, 253, 0.6) 0%, rgba(59, 130, 246, 0.6) 100%);
  border-color: rgba(191, 219, 254, 0.6);
}

.voice-btn-play {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.6) 0%, rgba(22, 163, 74, 0.6) 100%);
  color: #ffffff;
  border: 1px solid rgba(74, 222, 128, 0.5);
}

.voice-btn-play:hover {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.6) 0%, rgba(34, 197, 94, 0.6) 100%);
  border-color: rgba(134, 239, 172, 0.6);
}

.voice-btn-delete {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.6) 0%, rgba(220, 38, 38, 0.6) 100%);
  color: #ffffff;
  border: 1px solid rgba(248, 113, 113, 0.5);
}

.voice-btn-delete:hover {
  background: linear-gradient(135deg, rgba(248, 113, 113, 0.6) 0%, rgba(239, 68, 68, 0.6) 100%);
  border-color: rgba(254, 158, 158, 0.6);
}

.empty-state button {
  margin-top: 12px;
}

.config-modal {
  max-width: 420px;
}

.config-header {
  background: rgba(170, 170, 170, 0.15);
  border-radius: 24px 24px 0 0;
}

.config-header .modal-title {
  color: rgba(170, 170, 170, 0.9);
}

.config-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.config-title i {
  font-size: 20px;
  color: rgba(170, 170, 170, 0.7);
}

.config-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.config-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: rgba(60, 60, 60, 0.6);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.config-option:hover {
  background: rgba(80, 80, 80, 0.7);
}

.config-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.option-icon {
  width: 36px;
  height: 36px;
  background: rgba(170, 170, 170, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(170, 170, 170, 0.9);
  font-size: 16px;
  flex-shrink: 0;
}

.option-text {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

.config-footer {
  justify-content: flex-end;
  gap: 10px;
}

.btn-danger {
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.4) 0%, rgba(80, 80, 80, 0.3) 100%);
  border: 1px solid rgba(170, 170, 170, 0.3);
  color: rgba(170, 170, 170, 0.9);
}

.btn-danger:hover {
  background: linear-gradient(135deg, rgba(120, 120, 120, 0.5) 0%, rgba(100, 100, 100, 0.4) 100%);
  border-color: rgba(170, 170, 170, 0.5);
}
</style>
